export default "https://static.homerun-beta.co/images/icon-lens.png?f73c4d866fc911801fef9ffae82d93ae";